import React, { Component } from 'react'
import styled from 'styled-components'
import Text from '../../components/Text'

const Box = styled.div`
  padding: 1.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.3rem;
  font-weight: 300;
  border-bottom: 1px solid var(--light-gray);
`

export default class Title extends Component {
  render() {
    const { str, children } = this.props

    return (
      <Box>
        {str && <Text str={str} />}
        {!str && children}
      </Box>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Card/Title.js